import WebGalleryOnboardingRedirect from './WebGalleryOnboardingRedirect';

export default WebGalleryOnboardingRedirect;
